<style lang="less">
@import "../less/common.less";
@import "./login.less";
</style>
<template>
  <div class="main login">
    <div class="sunlight"></div>
    <div class="sunlight"></div>
    <div class="sunlight"></div>
    <div class="sunlight"></div>
    <!-- 测试项目权限 start -->
    <!-- <div>
      <button v-allow="'proj_edit'">项目编辑</button>
      <button v-allow="'proj_del1'">项目删除</button>
    </div> -->
    <!-- 测试项目权限 end -->
    <el-row :gutter="20">
      <el-col class="login_img" :span="12">&nbsp;</el-col>
      <el-col :span="12">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="">
            <p class="title-login">欢迎来到阿中分析系统</p>
            <div class="tips">请先登录账号</div>
          </el-form-item>
          <el-form-item>
            <img class="wx-logo" src="../image/weixinlogo.png" alt="..." @click="submitForm()" />
            <div class="wx-btn" @click="submitForm()">微信登录</div>
          </el-form-item>
        </el-form>
      </el-col>
      <img class="logo_img" src="../image/logo.png" alt="..." />
    </el-row>
  </div>
  </div>
</template>
<script>
import { localToken } from "@/libs/util";
import globConfig from "@/config/config";
import appApi from "@/api/api-app";
export default {
  data() {
    return {
      loadingBtn: false,
      ruleForm: {},
      rules: {},
    };
  },
  methods: {
    submitForm() {
      let that = this;
      let tenantId = that.$route.query.tenantId;
      // let tenantId = localToken.getTenant()
      if (tenantId) {
        // 切换租户
        appApi.setTenantSwitchById(tenantId).then(
          (res) => {
            window.location.href = globConfig.wxLoginUrl + tenantId;
          },
          (err) => {}
        );
      } else {
        window.location.href = globConfig.wxLoginUrl;
      }
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/view/login/login.vue